export function buildJobPostingLd(job) {
    const validThrough = job.expiration_date
        || new Date(Date.now() + 90 * 24 * 3600 * 1000).toISOString().slice(0, 10);
    const ld = {
        "@context": "https://schema.org/",
        "@type": "JobPosting",
        title: `${job.title} ${job.suffix || ""}`.trim(),
        description:
            `<p>${job.description || ""}</p>` +
            (job.tasks?.length ? `<ul>${job.tasks.map((t) => `<li>${t}</li>`).join("")}</ul>` : ""),
        datePosted: (job.created_at || "").slice(0, 10),
        validThrough,
        employmentType: "FULL_TIME",
        directApply: true,
        hiringOrganization: {
            "@type": "Organization",
            name: "Möbus Umweltschutz GmbH",
            sameAs: "https://moebus-umweltschutz.de",
        },
        jobLocation: {
            "@type": "Place",
            address: {
                "@type": "PostalAddress",
                streetAddress: "Andreas-Schubert-Str. 01",
                addressLocality: "Neustadt in Sachsen",
                addressRegion: "Sachsen",
                postalCode: "01844",
                addressCountry: "DE",
            },
        },
    };
    const min = Number(job.salary_min);
    const max = Number(job.salary_max);
    const hasMin = job.salary_min != null && job.salary_min !== "" && !isNaN(min) && min > 0;
    const hasMax = job.salary_max != null && job.salary_max !== "" && !isNaN(max) && max > 0;
    if (hasMin || hasMax) {
        const value = { "@type": "QuantitativeValue", unitText: job.salary_unit || "YEAR" };
        if (hasMin && hasMax) {
            value.minValue = min;
            value.maxValue = max;
        } else {
            value.value = hasMin ? min : max;
        }
        ld.baseSalary = { "@type": "MonetaryAmount", currency: "EUR", value };
    }
    return ld;
}
